import { ChangeDetectionStrategy, Component, HostBinding, signal } from '@angular/core';
import { NotificationsService } from '@core/services/notifications.service';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { INotificationEvento, INotificationResponse } from '@models/INotification';

@Component({
  selector: 'app-notifications',
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    CommonModule,
    TranslateModule,
    IconComponent,
    MatExpansionPanelTitle
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent {

  notifications = signal<INotificationEvento[]>([]);
  totalNotifications = signal<number>(0);
  readonly panelOpenState = signal(false);

  @HostBinding('style.display')
  get display() {
    return this.totalNotifications() > 0 ? 'block' : 'none';
  }


  constructor(
    private notificationsService: NotificationsService
  ) {
    this.notificationsService.getHomeNotifications().subscribe({
      next: (r: INotificationResponse) => {
        this.notifications.set(r.items);
        this.totalNotifications.set(r.total);
      },
      error: (err) => {

        console.warn('Error en notificaciones:', err.message);

      },
    });
  }
}
